import { render, staticRenderFns } from "./SelectedProductList.vue?vue&type=template&id=4d93206d&scoped=true"
import script from "./SelectedProductList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedProductList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectedProductList.vue?vue&type=style&index=0&id=4d93206d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d93206d",
  null
  
)

export default component.exports